/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The OrganizationObjectBaseDto model module.
 * @module model/OrganizationObjectBaseDto
 * @version v1.0.0
 */
class OrganizationObjectBaseDto {
    /**
     * Constructs a new <code>OrganizationObjectBaseDto</code>.
     * @alias module:model/OrganizationObjectBaseDto
     */
    constructor() { 
        
        OrganizationObjectBaseDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OrganizationObjectBaseDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrganizationObjectBaseDto} obj Optional instance to populate.
     * @return {module:model/OrganizationObjectBaseDto} The populated <code>OrganizationObjectBaseDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrganizationObjectBaseDto();

            if (data.hasOwnProperty('bannerUrl')) {
                obj['bannerUrl'] = ApiClient.convertToType(data['bannerUrl'], 'String');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('fullName')) {
                obj['fullName'] = ApiClient.convertToType(data['fullName'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('libraryBackendBasicUrl')) {
                obj['libraryBackendBasicUrl'] = ApiClient.convertToType(data['libraryBackendBasicUrl'], 'String');
            }
            if (data.hasOwnProperty('libraryFrontendBasicUrl')) {
                obj['libraryFrontendBasicUrl'] = ApiClient.convertToType(data['libraryFrontendBasicUrl'], 'String');
            }
            if (data.hasOwnProperty('logoUrl')) {
                obj['logoUrl'] = ApiClient.convertToType(data['logoUrl'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
            if (data.hasOwnProperty('shortName')) {
                obj['shortName'] = ApiClient.convertToType(data['shortName'], 'String');
            }
            if (data.hasOwnProperty('webUrl')) {
                obj['webUrl'] = ApiClient.convertToType(data['webUrl'], 'String');
            }
        }
        return obj;
    }


}

/**
 * banner url
 * @member {String} bannerUrl
 */
OrganizationObjectBaseDto.prototype['bannerUrl'] = undefined;

/**
 * Organization code
 * @member {String} code
 */
OrganizationObjectBaseDto.prototype['code'] = undefined;

/**
 * Organization description
 * @member {String} description
 */
OrganizationObjectBaseDto.prototype['description'] = undefined;

/**
 * Organization full name
 * @member {String} fullName
 */
OrganizationObjectBaseDto.prototype['fullName'] = undefined;

/**
 * Organization id
 * @member {Number} id
 */
OrganizationObjectBaseDto.prototype['id'] = undefined;

/**
 * backend url
 * @member {String} libraryBackendBasicUrl
 */
OrganizationObjectBaseDto.prototype['libraryBackendBasicUrl'] = undefined;

/**
 * backend url
 * @member {String} libraryFrontendBasicUrl
 */
OrganizationObjectBaseDto.prototype['libraryFrontendBasicUrl'] = undefined;

/**
 * logo url
 * @member {String} logoUrl
 */
OrganizationObjectBaseDto.prototype['logoUrl'] = undefined;

/**
 * Organization name
 * @member {String} name
 */
OrganizationObjectBaseDto.prototype['name'] = undefined;

/**
 * seq
 * @member {Number} seq
 */
OrganizationObjectBaseDto.prototype['seq'] = undefined;

/**
 * Organization short name
 * @member {String} shortName
 */
OrganizationObjectBaseDto.prototype['shortName'] = undefined;

/**
 * web url
 * @member {String} webUrl
 */
OrganizationObjectBaseDto.prototype['webUrl'] = undefined;






export default OrganizationObjectBaseDto;

